/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { StyledModal, ModalActions, ButtonGroup, Button } from 'sarsaparilla';

import { useAuthModal } from 'shared-ui/auth';

type BaseModalProps = {
    isOpen: boolean;
    onChange: (v: boolean) => void;
    closeModal: () => void;
};

export default function NotLoggedInModal({
    isOpen,
    closeModal,
    onChange,
}: BaseModalProps) {
    const { openLoginModal } = useAuthModal();

    const onProceedClick = () => {
        onChange(true);
        openLoginModal();
        closeModal();
    };

    return (
        <StyledModal
            shouldShowCloseButton
            shouldActionsStickInMobile
            size="md"
            isOpen={isOpen}
            heading="Trip Preferences"
            onRequestClose={closeModal}
        >
            <p>You have not logged in. Please log in to manage your trip preferences.</p>
            <ModalActions>
                <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                    <Button
                        appearance="tertiary"
                        onClick={closeModal}
                        clickTagCategory="Search"
                        clickTagAction="Cancel Button"
                        clickTagLabel="Log In To Manage Trip Preferences Modal"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onProceedClick}
                        clickTagCategory="Search"
                        clickTagAction="Proceed Button"
                        clickTagLabel="Log In To Manage Trip Preferences Modal"
                    >
                        Proceed
                    </Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}
